<template>
  <!-- D: 주문현황(주문내역:주문서) -->
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">주문현황</h1>
      <BreadCrumb :breadcrumbs="getBreadcrumbItems" />
    </div>

    <div class="l-content">
      <!-- D: 주문현황(주문내역:주문서) 페이지 -->
      <div class="p-order-history-wrap">
        <!-- D: 상단 탭 : 주문내역, 출고현황, 매입현황 -->
        <div class="c-tabs">
          <ul>
            <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
            <li class="tab-item">
              <a
                href="javascript:void(0);"
                @click="btnCmd('tab1Click', { tab1Index: 0 })"
                :class="[
                  'tab-anchor',
                  {
                    'is-active': data.tab1Index === 0,
                  },
                ]"
                role="tab"
                aria-selected
              >
                주문내역
              </a>
            </li>
            <li class="tab-item">
              <a
                href="javascript:void(0);"
                @click="btnCmd('tab1Click', { tab1Index: 1 })"
                :class="[
                  'tab-anchor',
                  {
                    'is-active': data.tab1Index === 1,
                  },
                ]"
                role="tab"
              >
                출고현황
              </a>
            </li>
            <li class="tab-item">
              <a
                href="javascript:void(0);"
                @click="btnCmd('tab1Click', { tab1Index: 2 })"
                :class="[
                  'tab-anchor',
                  {
                    'is-active': data.tab1Index === 2,
                  },
                ]"
                role="tab"
              >
                매입현황
              </a>
            </li>
          </ul>
        </div>
        <!-- D: c-tab-panel과 c-tab-panel-wrap은 세트임 -->
        <div class="c-tab-panel-wrap">
          <!-- tab content: tab1 -->
          <div
            class="tab-panel"
            role="tabpanel"
            aria-labelledby="tab4-1"
            :hidden="data.tab1Index != 0"
          ></div>
          <!-- tab content: tab2 -->
          <div
            class="tab-panel"
            role="tabpanel"
            aria-labelledby="tab4-2"
            :hidden="data.tab1Index != 1"
          >
            <ShipmentListTab @detail="(item) => openProdInfoPop(item)" />
          </div>
          <!-- tab content: tab3 -->
          <div
            class="tab-panel"
            role="tabpanel"
            aria-labelledby="tab4-3"
            :hidden="data.tab1Index != 2"
          ></div>
        </div>
        <!-- // D: 상단 탭 : 주문내역, 출고현황, 매입현황 -->

        <!-- D: 주문내역 조회&목록 -->
        <ShipmentListCont />
      </div>
    </div>

    <QuickMenu />
  </div>

  <ProdInfoPop
    v-if="isShowProdInfoPop"
    v-bind="prodInfoPopProps"
    @close="() => (isShowProdInfoPop = false)"
  />
</template>
<script setup name="shipmentList">
import {
  onMounted,
  reactive,
  watch,
  computed,
  ref,
  provide,
  readonly,
} from "vue";

import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";
import ShipmentListTab from "@/components/paintpro/order/shipmentListTab.vue";
import ShipmentListCont from "@/components/paintpro/order/shipmentListCont.vue";
import { useRoute, useRouter } from "vue-router";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
import * as orderApi from "@/api/orderApi.js";
import ProdInfoPop from "@/components/paintpro/prod/prodInfoPop.vue";

const router = useRouter();
const route = useRoute();

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    basketCount: 0,
    userLoginInfo: {},
    breadcrumbItems: [],
    query: {},
    path: "",
    empIndex: 0,
    selectedBranch: {},
  },
  codes: {
    CODE_WERKS: [],
    CODE_GOODS_FILE_SE_CD: [],
  },
  popup: {
    isModalVisible: false,
    isModalVisible2: false,
    isCurrentInquery: true,
    showMoDetailPopup: false,
  },
  tab1Index: 0,
  eventBus: {
    salesPersonIndex: 0,
  },
});

const prodInfoPopProps = ref({
  matnr: null,
}); // 제품상세팝업
const isShowProdInfoPop = ref(false);
provide("CODE_WERKS", readonly(data.codes.CODE_WERKS));
provide("CODE_GOODS_FILE_SE_CD", readonly(data.codes.CODE_GOODS_FILE_SE_CD));

watch(
  () => store.useBasketCountStore().basketCount,
  (newValue) => {
    data.page.basketCount = newValue;
  }
);

// GNB 영업사원 리스트 연동
watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  async (newValue) => {
    if (newValue >= 0 && data.page.userLoginInfo?.empList?.length > newValue) {
      data.page.empIndex = newValue;
      data.page.selectedBranch =
        data.page.userLoginInfo.empList[data.page.empIndex];
    }
  }
);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  data.page.query = useRoute().query || {};
  data.tab1Index = 1;
  await pageInitData();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  mparm.push({ qId: "cmCode_code1", parm: { cdGrp: "WERKS" } });
  mparm.push({ qId: "cmCode_code2", parm: { cdGrp: "GOODS_FILE_SE_CD" } });
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: shipmentList.pageInitData] `);
    return false;
  }

  data.page.path = route.path;
  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
  data.page.userLoginInfo = store.useAuthStore()?.user;
  data.codes.CODE_WERKS = res.data.cmCode_code1;
  data.codes.CODE_GOODS_FILE_SE_CD = res.data.cmCode_code2;

  // 영업사원 디폴트
  data.eventBus.salesPersonIndex = store.useEventBusStore()?.salesPersonIndex;
  data.page.selectedBranch =
    data.page.userLoginInfo.empList[data.eventBus.salesPersonIndex];
}

const getBreadcrumbItems = computed(() => {
  let list = [
    { name: "주문현황", path: "/paintpro/orderList" },
    { name: "출고현황", path: "" },
  ];
  return list;
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "tab1Click") {
    data.tab1Index = parms.tab1Index;
    if (parms.tab1Index === 0) {
      router.push({
        path: "/paintpro/orderList",
      });
    } else if (parms.tab1Index === 1) {
      router.push({
        path: "/paintpro/orderList/shipmentList",
      });
    } else if (parms.tab1Index === 2) {
      router.push({
        path: "/paintpro/orderList/purchaseList",
      });
    }
  } else if (cmd === "biz1#moDetail") {
    data.popup.showMoDetailPopup = true;
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

// 제품 상세 팝업
function openProdInfoPop(item) {
  prodInfoPopProps.value.matnr = item.matnr;
  isShowProdInfoPop.value = true;
}

// 상세팝업에서 장바구니 담기
const addCartItem = async (param = { product: null, quantity: 0 }) => {
  await cmApi.insertUserBasketProd({
    goodsSn: param.product.goodsSn,
    goodsQty: param.quantity,
    vwerk: data.page.userLoginInfo.vwerk,
    zzlqdCls: param.product.zzlqdCls,
  });
};
provide("addCartItem", addCartItem);

// 상세팝업에서 바로주문
const addBuyItem = async (product) => {
  const param = {
    goodsSn: product.goodsSn,
    goodsQty: product.quantity,
    zempNo: data.page.selectedBranch.kunn2,
    path: data.page.path,
  };
  await orderApi.createTempOrder(param);
};
provide("addBuyItem", addBuyItem);
</script>
<style scoped></style>
